import React from 'react';

const SebraeDocuments: React.FC = () => (
<>
    <div key={'company-docs'} className="box">
        <h3>Documentação da empresa MEI e ME:</h3>
        <ul>
            <li>
                <span className="font-weight-bold">MEI:</span> Certificado de MEI
            </li>
            <li>
                <span className="font-weight-bold">ME:</span> Contrato Social ou Requerimento de Empresário
            </li>
            <li>
                Declaração de faturamento anual referente ao ano de 2019 assinada pela empresa e por seu contador
            </li>
            <li>Extratos bancários da conta PJ dos últimos 90 dias</li>
        </ul>

        <h3 className="mt-5">Documentação CNPJ Produtor Rural Pessoa Física:</h3>
        <span>
            Enviar <span className="font-weight-bold">um</span> dos itens abaixo:
        </span>
        <ul>
            <li>DAP válida (DECLARAÇÃO DE APTIDÃO AO PRONAF)</li>
            <li>Declaração de IR</li>
            <li>Declaração de faturamento anual referente a 2019 assinada pelo contador</li>
            <li>Notas Fiscais emitidas</li>
            <li>Extrato bancário PJ ou PF dos últimos 90 dias</li>
        </ul>
    </div>
    <div key={"partner-docs"} className="box">
        <h3>Documentos dos donos da empresa:</h3>
        <ul>
            <li>Identidade do(s) sócio(s)</li>
            <li>CPF do(s) sócio(s)</li>
            <li>Faça uma Selfie: tire uma foto nítida segurando o seu documento de identidade aberto</li>
            <li>Comprovante de residência (conta de luz, água, gás, telefone ou internet com prazo de no máximo 90 dias)</li>
        </ul>
    </div>
</>
);

export default SebraeDocuments;